import { render } from "./dynamic-view-switcher.vue?vue&type=template&id=70e81eca&ts=true"
import script from "./dynamic-view-switcher.vue?vue&type=script&lang=ts"
export * from "./dynamic-view-switcher.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__